module.exports = __webpack_public_path__ + "b3e825cc29b6fa7a45d25297a3a23af9.svg";